<template>
    <!-- ============================================== SIDEBAR ============================================== -->
    <div :class="type != 'header' ? 'col-xs-12 col-sm-12 col-md-3 sidebar' : 'col-12 sidebar'">
      <!-- ================================== TOP NAVIGATION ================================== -->
      <!-- <div class="side-menu animate-dropdown outer-bottom-xs"> -->
      <div class="side-menu animate-dropdown">
        <div v-if="type != 'header'" class="head"><i class="icon fa fa-align-justify fa-fw"></i> Danh mục sản phẩm</div>
        <nav class="yamm megamenu-horizontal">
          <template>
            <ul class="nav">
              <li class="dropdown menu-item" v-for="root in lstCateRoot" :key="root.id">
                <a @click="$router.push({name: 'Product' ,query: {code: root.code}})" class="dropdown-toggle" data-hover="dropdown">
                  <!-- <i class="icon fa fa-shopping-bag" aria-hidden="true"></i> -->
                  {{root.name}}
                </a>
                <ul class="dropdown-menu mega-menu" v-if="root.lstChild !== null && root.lstChild.length > 0">
                  <li class="yamm-content">
                    <div class="row">
                      <div class="col-sm-12 col-md-3" v-for="node in root.lstChild" :key="node.id">
                        <h2 class="title" @click="$router.push({name: 'Product' ,query: {code: node.code}})">{{node.name}}</h2>
                        <ul style="padding-left: 10px" class="links list-unstyled">
                          <li @click="$router.push({name: 'Product' ,query: {code: nodeEnd.code}})" v-for="nodeEnd in node.lstChild" :key="nodeEnd.id"><span>{{nodeEnd.name}}</span></li>
                        </ul>
                      </div>
                    </div>
                    <!-- /.row -->
                  </li>
                  <!-- /.yamm-content -->
                </ul>
                <!-- /.dropdown-menu --> </li>
              <!-- /.menu-item -->


            </ul>
          </template>
          <!-- /.nav -->
        </nav>
        <!-- /.megamenu-horizontal -->
      </div>
      <!-- /.side-menu -->
      <!-- ================================== TOP NAVIGATION : END ================================== -->

      <!-- ============================================== HOT DEALS ============================================== -->
      <!-- <div class="sidebar-widget hot-deals wow fadeInUp outer-bottom-xs">
        <h3 class="section-title">Giảm giá đặc biệt</h3>
        <div class="owl-carousel sidebar-carousel custom-carousel owl-theme outer-top-ss">
          <div class="item">
            <div class="products">
              <div class="hot-deal-wrapper">
                <div class="image"><img src="/static/img/flip/hot-deals/p25.jpg" alt=""></div>
                <div class="sale-offer-tag"><span>49%<br>
                    off</span></div>
                <div class="timing-wrapper">
                  <div class="box-wrapper">
                    <div class="date box"><span class="key">120</span> <span class="value">DAYS</span></div>
                  </div>
                  <div class="box-wrapper">
                    <div class="hour box"><span class="key">20</span> <span class="value">HRS</span></div>
                  </div>
                  <div class="box-wrapper">
                    <div class="minutes box"><span class="key">36</span> <span class="value">MINS</span></div>
                  </div>
                  <div class="box-wrapper hidden-md">
                    <div class="seconds box"><span class="key">60</span> <span class="value">SEC</span></div>
                  </div>
                </div>
              </div>

              <div class="product-info text-left m-t-20">
                <h3 class="name"><a href="detail.html">Floral Print Buttoned</a></h3>
                <div class="rating rateit-small"></div>
                <div class="product-price"><span class="price"> $600.00 </span> <span class="price-before-discount">$800.00</span>
                </div>

              </div>

              <div class="cart clearfix animate-effect">
                <div class="action">
                  <div class="add-cart-button btn-group">
                    <button class="btn btn-primary icon" data-toggle="dropdown" type="button"><i
                      class="fa fa-shopping-cart"></i></button>
                    <button class="btn btn-primary cart-btn" type="button">Add to cart</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="products">
              <div class="hot-deal-wrapper">
                <div class="image"><img src="/static/img/flip/hot-deals/p5.jpg" alt=""></div>
                <div class="sale-offer-tag"><span>35%<br>
                    off</span></div>
                <div class="timing-wrapper">
                  <div class="box-wrapper">
                    <div class="date box"><span class="key">120</span> <span class="value">Days</span></div>
                  </div>
                  <div class="box-wrapper">
                    <div class="hour box"><span class="key">20</span> <span class="value">HRS</span></div>
                  </div>
                  <div class="box-wrapper">
                    <div class="minutes box"><span class="key">36</span> <span class="value">MINS</span></div>
                  </div>
                  <div class="box-wrapper hidden-md">
                    <div class="seconds box"><span class="key">60</span> <span class="value">SEC</span></div>
                  </div>
                </div>
              </div>

              <div class="product-info text-left m-t-20">
                <h3 class="name"><a href="detail.html">Floral Print Buttoned</a></h3>
                <div class="rating rateit-small"></div>
                <div class="product-price"><span class="price"> $600.00 </span> <span class="price-before-discount">$800.00</span>
                </div>

              </div>

              <div class="cart clearfix animate-effect">
                <div class="action">
                  <div class="add-cart-button btn-group">
                    <button class="btn btn-primary icon" data-toggle="dropdown" type="button"><i
                      class="fa fa-shopping-cart"></i></button>
                    <button class="btn btn-primary cart-btn" type="button">Add to cart</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="products">
              <div class="hot-deal-wrapper">
                <div class="image"><img src="/static/img/flip/hot-deals/p10.jpg" alt=""></div>
                <div class="sale-offer-tag"><span>35%<br>
                    off</span></div>
                <div class="timing-wrapper">
                  <div class="box-wrapper">
                    <div class="date box"><span class="key">120</span> <span class="value">Days</span></div>
                  </div>
                  <div class="box-wrapper">
                    <div class="hour box"><span class="key">20</span> <span class="value">HRS</span></div>
                  </div>
                  <div class="box-wrapper">
                    <div class="minutes box"><span class="key">36</span> <span class="value">MINS</span></div>
                  </div>
                  <div class="box-wrapper hidden-md">
                    <div class="seconds box"><span class="key">60</span> <span class="value">SEC</span></div>
                  </div>
                </div>
              </div>

              <div class="product-info text-left m-t-20">
                <h3 class="name"><a href="detail.html">Floral Print Buttoned</a></h3>
                <div class="rating rateit-small"></div>
                <div class="product-price"><span class="price"> $600.00 </span> <span class="price-before-discount">$800.00</span>
                </div>

              </div>

              <div class="cart clearfix animate-effect">
                <div class="action">
                  <div class="add-cart-button btn-group">
                    <button class="btn btn-primary icon" data-toggle="dropdown" type="button"><i
                      class="fa fa-shopping-cart"></i></button>
                    <button class="btn btn-primary cart-btn" type="button">Add to cart</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- ============================================== HOT DEALS: END ============================================== -->


      <!--          <div class="home-banner"><img src="/static/img/flip/banners/LHS-banner.jpg" alt="Image"></div>-->
    </div>
    <!-- ============================================== SIDEBAR : END ============================================== -->
</template>

<script>

export default {
  name: 'SideBar',
  props: ["type"],
  components: {},
  data: function () {
    return {
      lstCateRoot: []
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadDataCategories();
  },
  methods: {
    loadDataCategories: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/category/findAllCateActive",
        successCallback: function (response) {
          that.lstCateRoot = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  watch: {}
}
</script>
<style scoped>
li:nth-child(1){
  cursor: pointer;
}

a:hover {
  color: #428bca !important;
  cursor: pointer;
}

span:hover {
  color: #428bca !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/SideBar.vue